import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import googleAnalytics from '../services/googleAnalyticsService';

// Hook to automatically track page views on route changes
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    googleAnalytics.trackPageView(location.pathname + location.search);
  }, [location]);
};

// Hook for manual analytics tracking
export const useGoogleAnalytics = () => {
  return {
    trackPageView: googleAnalytics.trackPageView.bind(googleAnalytics),
    trackEvent: googleAnalytics.trackEvent.bind(googleAnalytics),
    trackLogin: googleAnalytics.trackLogin.bind(googleAnalytics),
    trackSignup: googleAnalytics.trackSignup.bind(googleAnalytics),
    trackButtonClick: googleAnalytics.trackButtonClick.bind(googleAnalytics),
    trackGameLaunch: googleAnalytics.trackGameLaunch.bind(googleAnalytics),
    trackDeposit: googleAnalytics.trackDeposit.bind(googleAnalytics),
    trackWithdrawal: googleAnalytics.trackWithdrawal.bind(googleAnalytics),
    trackBetPlaced: googleAnalytics.trackBetPlaced.bind(googleAnalytics),
    trackSearch: googleAnalytics.trackSearch.bind(googleAnalytics),
    trackError: googleAnalytics.trackError.bind(googleAnalytics),
    setUserId: googleAnalytics.setUserId.bind(googleAnalytics),
    setUserProperties: googleAnalytics.setUserProperties.bind(googleAnalytics),
    getAffiliateRef: googleAnalytics.getAffiliateRef.bind(googleAnalytics),
    captureAffiliateRefFromUrl: googleAnalytics.captureAffiliateRefFromUrl.bind(googleAnalytics),
  };
};

export default useGoogleAnalytics;

